export const Events = {
    InboxNewMessagesNotification: "InboxNewMessagesNotification",
    APIError: "APIError",
    APIErrorHide: "APIErrorHide",
    Notification: "Notification",
    OrderTaskNotification: "OrderTaskNotification"
};
